<template>
    <v-dialog v-model="open" max-width="520" persistent>
        <v-card>
            <v-card-title class="d-flex justify-space-between align-center">
                {{ titleProp }}
                <v-btn icon @click="$emit('close', null)">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pb-0">
                <div class="signature-canvas-container">
                    <vue-drawing-canvas
                        ref="signatureCanvas"
                        :initial-image="signatureAttachmentProp ? signatureAttachmentProp.strokes : []"
                        line-join="round"
                        :height="250"
                        :width="canvasWidth"
                    />
                </div>
            </v-card-text>

            <v-card-actions class="justify-center pa-4">
                <v-btn outlined @click="undoCanvas">
                    <v-icon left>mdi-undo</v-icon>Undo
                </v-btn>
                <v-btn outlined color="error" @click="clearCanvas">
                    <v-icon left>mdi-delete-outline</v-icon>Clear
                </v-btn>
                <v-spacer />
                <v-btn text @click="$emit('close', null)">Cancel</v-btn>
                <v-btn color="primary" @click="submitCanvas">
                    <v-icon left>mdi-check</v-icon>Submit
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import VueDrawingCanvas from 'vue-drawing-canvas';

export default {
    name: 'capture-signature-dialog',
    components: {
        VueDrawingCanvas,
    },
    props: {
        titleProp: {
            type: String,
            default: 'Capture Signature',
        },
        signatureAttachmentProp: {
            type: Object,
            default: () => null,
        },
    },
    data: () => ({
        open: true,
        canvasWidth: 460,
    }),
    mounted() {
        this.$nextTick(() => {
            const cardContent = this.$el.querySelector('.v-card__text');
            if (cardContent) {
                this.canvasWidth = cardContent.clientWidth - 48;
            }
        });
    },
    methods: {
        clearCanvas() {
            this.$refs.signatureCanvas.reset();
        },
        undoCanvas() {
            this.$refs.signatureCanvas.undo();
        },
        submitCanvas() {
            const canvas = this.$refs.signatureCanvas;

            if (!canvas || canvas.isEmpty()) {
                this.$emit('close', null);
                return;
            }

            const canvasEl = canvas.$el instanceof HTMLCanvasElement
                ? canvas.$el
                : canvas.$el.querySelector('canvas');

            this.$emit('close', {
                attachmentSource: canvasEl.toDataURL('image/png'),
                strokes: canvas.getAllStrokes(),
            });
        },
    },
};
</script>

<style scoped>
.signature-canvas-container {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    overflow: hidden;
    line-height: 0;
}
</style>
